import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "@/App";
import configureStore from "@/store";
import initialState from "@/store/initialState";
import "@/utils/ubaInitializer.utils";

import "bootstrap/dist/css/bootstrap.min.css";
import "@/index.css";

const store = configureStore(initialState);

const root: ReactDOM.Root = ReactDOM.createRoot(
  document.getElementById("root")!,
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>
);
